function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3.5 13.5L0.00353535 9.99576L0.999091 8.99949L3.5 11.499L5.99949 8.99949L7 9.99929L3.5 13.5ZM0.999091 5.00051L0 4L3.5 0.5L6.99576 4.00354L6.0002 4.99909L3.5 2.5003L0.999091 5.00051Z",
  fill: "white"
});

const SvgArrowUnfoldMore = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 7,
  height: 14,
  viewBox: "0 0 7 14",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowUnfoldMore, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow_unfold_more.792abd49.svg";
export { ForwardRef as ReactComponent };